import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=e0118214"
import script from "./Alert.vue?vue&type=script&setup=true&lang=ts"
export * from "./Alert.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports